import Carousel from '../../Carousel';
import { useState, useEffect, useCallback } from 'react';

import showcaseService from 'services/showcase';
import { IShowcaseSchool } from 'interface/showcase';
import Card from './SchoolCard';

interface IProps {
  title: string;
}

const SchoolsShelf = (props: Partial<IProps>) => {
  const [schools, setSchools] = useState<IShowcaseSchool[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchSchools = useCallback(() => {
    setLoading(true);
    return showcaseService
      .getShowcaseSchool<IShowcaseSchool[]>()
      .then(setSchools)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchSchools();
  }, [fetchSchools]);

  return (
    <Carousel
      id='showcase-shelf-school'
      title={props.title}
      isEmpty={schools.length === 0}
      loadingShelf={loading && schools.length === 0}
    >
      {schools.map((school) => (
        <Card key={school.id} school={school} />
      ))}
    </Carousel>
  );
};

export default SchoolsShelf;
